import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import { DEFAULT_NODE_SUMMARY } from '../constants';
let NodesSummaryModelImpl = class NodesSummaryModelImpl extends AbstractModel {
    constructor() {
        super(...arguments);
        this._modelData = {};
    }
    get nodeSummaryDataSet() {
        return this._modelData;
    }
    clear() {
        this.updateData({});
    }
    updateSummaryById(id, summary) {
        this.updateData({
            ...this._modelData,
            [id]: summary,
        });
    }
    getSummaryById(id) {
        return this._modelData[id] || DEFAULT_NODE_SUMMARY;
    }
    updateData(data) {
        this.update(() => {
            return data;
        });
    }
    dispose() {
        this.updateData({});
    }
};
NodesSummaryModelImpl = __decorate([
    injectable()
], NodesSummaryModelImpl);
export { NodesSummaryModelImpl };
